<template>
  <header>
    <nav v-if="$route.name !== 'end'">
      <router-link :to="{name: 'photos'}">
        <span class="icon">1</span>
      </router-link>
      <router-link :to="{name: 'infos'}">
        <span class="icon">2</span>
      </router-link>
      <router-link :to="{name: 'confirm'}">
        <span class="icon">3</span>
      </router-link>
    </nav>
    <nav v-else>
      <a href="#" class="router-link-exact-active">
        <i class="icon icon-plane"></i>
      </a>
    </nav>
    <h1 v-html="$route.meta.title"></h1>
  </header>
</template>

<script>
  export default {}
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  header {
    text-align: center;
    background-color: color('background');
    padding: spacer(2) spacer();
  }

  nav {
    display: inline-flex;
    align-items: center;
    position: relative;
    z-index: 0;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      z-index: -1;
      border-bottom: 3px dotted color('secondaryBlue');
    }
  }

  a {
    width: 2.25em;
    height: 2.25em;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border: 1px solid transparent;
    font-size: 1.2em;
    background-color: color('secondaryBlue');
    color: white;
    border-radius: 999px;

    &:not(:first-child) {
      margin-left: 1.5rem;
    }

    &:not(:last-child) {
      margin-right: 1.5rem;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.router-link-exact-active {
      background-color: color('primaryBlue');
      box-shadow: 0 0 0 4px color('primaryBlue');

      .icon {
        font-size: 1.25em;
      }
    }

    &.router-link-exact-active ~ a {
      background-color: color('background');
      color: color('secondaryBlue');
      border-color: currentColor;
    }
  }

  h1 {
    color: color('secondaryBlue');
    text-align: center;
    font-weight: 300;
    font-size: 1.5em;
    line-height: 1;
    margin-top: spacer(2);
    margin-bottom: 0;
  }
</style>
